import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import QuizBlockChoose from './Components/BlockQuiz'
//import MemoryClass from "./memoryClass";
import axios from 'axios';

// const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";
let ASSETS_BASE = '';
    if(true){
          ASSETS_BASE = '/global17/bundles/games/dist'; //head-game-4
    }else{
          ASSETS_BASE = '';
    }


//CLASSE MEMORY GAME
class QuizGame extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            quiz:[
                {
                    title:'Quale di queste razze indica sia quella di un cane che quella di un gatto? ',
                    choose1:'Bobtail',
                    choose2:'Ragdoll',
                    choose3:'Bichon Havanais',
                } ,   {
                    title:'Quali colori riesce a distinguere bene il cane?',
                    choose1:'Rosso – Verde ',
                    choose2:'Blu – Giallo',
                    choose3:'Arancione – Rosso ',
                } , {
                    title:'Rispetto alla sua altezza, quanto in alto può saltare un gatto?  ',
                    choose1:'5-7 volte la sua altezza',
                    choose2:'1-3 volte la sua altezza ',
                    choose3:'8-10 volte la sua altezza  ',
                } , {
                    title:'Quante ossa formano la struttura ossea di un gatto adulto? ',
                    choose1:'210',
                    choose2:'230 ',
                    choose3:'275',
                } ,  {
                    title:'Quale di queste razze canine è nota per non abbaiare? ',
                    choose1:'Bassotto',
                    choose2:'Samoiedo',
                    choose3:'Basenji ',
                } , {
                    title:'Quante dita hanno, in totale, i gatti? ',
                    choose1:'18',
                    choose2:'20',
                    choose3:'24',
                },  {
                    title:'Quale, tra i seguenti, è un alimento nocivo per il cane? ',
                    choose1:'Aglio',
                    choose2:'Melone',
                    choose3:'Carota',
                }  ,  {
                    title:'Quanto dura, in media, la gravidanza del cane?',
                    choose1:'63 giorni',
                    choose2:'36 giorni',
                    choose3:'82 giorni',
                } , {
                    title:'Quale, tra i seguenti, è un alimento che non può mangiare il gatto?  ',
                    choose1:'Fragola',
                    choose2:'Patata',
                    choose3:'Avocado',
                }, {
                    title:'I gatti, solitamente, fanno le fusa per comunicare... ',
                    choose1:'Benessere e appagamento',
                    choose2:'Ansia e stress',
                    choose3:'Voglia di giocare',
                }
            ],
            logged:true,
            choose:[],
            match:["1","2","1","2","3","1","1","1","3","1"],
            winGame:false,
            step:0,
            countMatch:0,
            remainingTime:   90,
            started: false,
            ended: false,
            img:   ""
        }
        //bind methods
        this.startTimer  = this.startTimer.bind(this);
        this.stepChoose  = this.stepChoose.bind(this);
        this.nextStep  = this.nextStep.bind(this);
        this.saveResult  = this.saveResult.bind(this);

    }
    componentDidMount() {
        this.setState(
            { logged: document.getElementById("gamefour2").getAttribute("logged") === "true" ? true : false }
        )
        //this.startTimer()
    }
    end(win = false) {
        if(win)
            console.log("Winner!");
        else
            console.log("Loser!");
    }



    startTimer() {
        this.setState({started: true}, () => {
            setInterval(() => {
                if(this.state.started && !this.state.ended)
                    if(this.state.remainingTime === 1)
                        this.setState({
                            remainingTime: this.state.remainingTime - 1,
                            started: true,
                            ended:   true
                        }, () => {
                            this.end();
                        });
                    else
                        this.setState({
                            remainingTime: this.state.remainingTime - 1
                        });
            }, 1000);
        });
    }

    nextStep( e ){
        //contatore risposte corrette
        if( e  == this.state.match[this.state.step]  ) {
            this.setState({
                countMatch: this.state.countMatch += 1
            })
        }
        console.log([ this.state.step, this.state.quiz.length, 'result' , e,   this.state.match[this.state.step],  this.state.countMatch  ])
            this.setState({
                choose:  [...this.state.choose,e],
                step: this.state.step +=1
            }, ()=> {
                this.setState({
                    ended:(this.state.choose.length !=  this.state.quiz.length    ) ? false : true
                })
            })

    }
    saveResult() {

        if(this.state.ended){

            let self = this;
            axios({
                method: 'get',
                url: '/giochi/add-result-by-userid?totalMatch='+self.state.countMatch,
            })
                .then(function (response) {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }


    stepChoose(){
        //LOGIN TRUE
        let totalMatch =  this.state.countMatch;
        /*console.log( "stepChoose " + this.state.countMatch );*/
        if(this.state.logged){

                let final = (  this.state.step > this.state.quiz.length -1  ) ? false : true;

                if( this.state.remainingTime == 0 ){
                     this.saveResult();
                    return (
                        <div className={'popupstyle'}>
                            <div>
                                <h3>   COMPLIMENTI   </h3>
                                <p><b style={{ fontWeight:'bold' }}>QUANTO NE SAI SU CANE E GATTO? </b></p>
                                <p>Hai risposto correttamente a { this.state.countMatch  } domande su { this.state.quiz.length } !</p>
                                <p>Grazie per aver partecipato, ecco il codice sconto da utilizzare su purinashop.it:</p>
                                <h3>PETPASSION2021</h3>
                                <p>Il buono sconto ha un valore di 10€ su una spesa di 50€. Puoi utilizzare il buono sconto dal 20/01 al 20/02.  </p>
                                <a className={'btn btnpoup'} href={'https://www.purinashop.it/'}>Vai al Purinashop</a> <a onClick={()=>{ location.reload() }} className={'btn btnpoup'}>Gioca di nuovo</a>

                                {/*btn btn-default btnChoose*/}
                            </div>
                        </div>
                    )
                }
                if(final){

                    return(
                        <QuizBlockChoose
                            customCallback={  this.nextStep }
                            title  ={ this.state.quiz[this.state.step].title }
                            choose1={ this.state.quiz[this.state.step].choose1 }
                            choose2={ this.state.quiz[this.state.step].choose2 }
                            choose3={ this.state.quiz[this.state.step].choose3 }
                        />
                    )
                }  else {
                     this.saveResult();
                    return (
                        <div className={'popupstyle'}>
                            <div>
                                <h3>   COMPLIMENTI   </h3>
                                <p><b style={{ fontWeight:'bold' }}>QUANTO NE SAI SU CANE E GATTO? </b></p>
                                <p>Hai risposto correttamente a { this.state.countMatch  } domande su { this.state.quiz.length } !</p>
                                <p>Grazie per aver partecipato, ecco il codice sconto da utilizzare su purinashop.it:</p>
                                <h3>PETPASSION2021</h3>
                                <p>Il buono sconto ha un valore di 10€ su una spesa di 50€. Puoi utilizzare il buono sconto dal 20/01 al 20/02.  </p>
                                <a className={'btn btnpoup'} href={'https://www.purinashop.it/'}>Vai al Purinashop</a> <a onClick={()=>{ location.reload() }} className={'btn btnpoup'}>Gioca di nuovo</a>

                            {/*btn btn-default btnChoose*/}
                            </div>
                        </div>
                    )
                }
        }
       /* else{
            return(<div className={""} style={{textAlign: "center", padding: "2em 0"}}>
                <button style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
                    Accedi / Registrati per giocare!
                </button>
            </div> )
        }*/
    }

    render(){

        const { remainingTime, started , logged } = this.state;

        return (
<div>
            <div>
                {logged && !started &&(
                    <div className={""} style={{textAlign: "center", padding: "2em 0"}}>
                        <button onClick={()=>{
                            this.startTimer();
                        }} style={{ maxWidth:"400px", margin: "0 auto", padding: "1em 3em", background: "#ffffff", color: "#EA2328", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"}  >
                            Clicca per giocare!
                        </button>
                    </div>
                )}
                {logged && started && (
                    <div className={"container-fluid"}>

                        <div style={{ marginBottom:"50px" }} >
                            <img style={{ width:"300px"}} src={ ASSETS_BASE + "/images/logoQuiz.svg" } alt="SVG logo" />
                        </div>

                        <div className={'row'}>
                            <div className={'col-md-2 col-xs-12'}>  </div>
                            <div className={'col-md-8 col-xs-12 bodyGame'}>
                                <img className={"time-icon"} src={ ASSETS_BASE + "/images/time.png"} />
                                <span className={"time-remaining"}>
									TEMPO RESIDUO <strong><Timer started={started} remainingTime={remainingTime} /></strong>
 								</span>
                                <div>
                                    {   this.stepChoose()  }
                                </div>
                            </div>
                            <div className={'col-md-2 col-xs-12'}> </div>
                        </div>
                    </div>
            )}
                { !logged &&(
                    <div className={""} style={{textAlign: "center", padding: "2em 0"}}>
                        <button style={{ maxWidth:"400px", margin: "0 auto", padding: "1em 3em", background: "#ffffff", color: "#EA2328", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
                            Accedi / Registrati per giocare!
                        </button>
                    </div>
                ) }
            </div>


        <div>




                {/*<div className={"header"}>
                    <div className={"container"}>
                        <div className={"logo"}>Logo purina</div>
                        <div className={"flex j-center a-center"}>
                            <div className={"time flex j-center a-center"}>
                                <img className={"time-icon"} src={ASSETS_BASE + "/images/time.png"} />
                                <span className={"time-remaining"}>
									TEMPO RESIDUO <strong><Timer started={started} remainingTime={remainingTime} /></strong>
 								</span>
                            </div>
                        </div>
                        <div className={"time flex j-center a-center"}>
                            <h1> GAME MEMORY 111</h1>
                            <div className={"win_block"}>
                                Complimenti hai vinto!
                            </div>
                        </div>
                    </div>
                </div>*/}


        </div>
            </div>
        )
    }
}

const Timer = ({ remainingTime }) => {
    const mins = Math.floor(remainingTime/60) < 10 ? `0${Math.floor(remainingTime/60)}` : Math.floor(remainingTime/60);
    const secs = (remainingTime%60) < 10 ? `0${(remainingTime%60)}` : (remainingTime%60);
    return (
        <Fragment>
            {mins}:{secs}
        </Fragment>
    );
}



document.addEventListener("DOMContentLoaded", () => {
    const mountPoint = document.getElementById("gamefour");
    if(mountPoint)
        ReactDOM.render(<QuizGame />, mountPoint);
});
